import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest, useUserRole } from 'hooks';

import { SnapTransactions } from 'codegen';

import { IssuancesTable } from './IssuancesTable';
import { columns } from './lib';

export const Transactions = () => {
  const { snapId } = useParams();
  const { data, loading, refresh } = useGetRequest<SnapTransactions>({ url: `/snaps/${snapId}/transactions` });

  const { isAdmin } = useUserRole();

  const dataSource = data?.transactions;

  return (
    <MilesTable
      size='small'
      rowKey='id'
      loading={loading}
      columns={columns(isAdmin, refresh)}
      dataSource={dataSource}
      expandable={{
        rowExpandable: ({ issuances }) => !!issuances?.length,
        expandedRowRender: ({ id, issuances }) => <IssuancesTable transactionId={id} dataSource={issuances} />,
      }}
    />
  );
};
